import { Component } from '@angular/core';

@Component({
  selector: 'waves',
  template: `
<div class="animated fadeIn primary-text">
  <div class="sk-wave">
    <div class="sk-rect sk-rect1"></div>
    <div class="sk-rect sk-rect2"></div>
    <div class="sk-rect sk-rect3"></div>
    <div class="sk-rect sk-rect4"></div>
    <div class="sk-rect sk-rect5"></div>
  </div>
</div>
  `,
})
export class WavesComponent {
  constructor() { }

}



// WEBPACK FOOTER //
// ./src/app/shared/waves.component.ts